define('apps/course-intro/templates/items/module',['handlebars'], function(Handlebars) {

return Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n    <a href=\"./module-player.html#level/";
  if (stack1 = helpers.levelNum) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.levelNum); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "/";
  if (stack1 = helpers.levelGuid) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.levelGuid); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "/module/";
  if (stack1 = helpers.itemIndex) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.itemIndex); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "/";
  if (stack1 = helpers._id) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0._id); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "\" class=\"module-link player-asset\" data-guid=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.thumbnail)),stack1 == null || stack1 === false ? stack1 : stack1.assetGuid)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" data-type-id=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.thumbnail)),stack1 == null || stack1 === false ? stack1 : stack1.typeId)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" data-layout=\"background\">\n        <section class=\"teaser\">\n            <span class=\"icon player-asset\" data-guid=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.icon)),stack1 == null || stack1 === false ? stack1 : stack1.assetGuid)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" data-type-id=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.icon)),stack1 == null || stack1 === false ? stack1 : stack1.typeId)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" data-layout=\"background\">&nbsp;</span>\n            <span class=\"module-id\">Module ";
  if (stack2 = helpers.itemIndex) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.itemIndex); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "</span>\n            <span class=\"module-title\">";
  if (stack2 = helpers.title) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.title); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "</span>\n        </section>\n        <section class=\"detail transition-opacity\">\n            <header>\n                <h1>";
  if (stack2 = helpers.title) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.title); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "</h1>\n            </header>\n            <p>";
  if (stack2 = helpers.description) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.description); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "</p>\n        </section>\n    </a>\n";
  return buffer;
  }

function program3(depth0,data) {
  
  
  return "\n    <section class=\"lock-display\">\n        <span class=\"fa fa-lock\"></span>\n    </section>\n";
  }

  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isUnlocked), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  })

});
